import React, { Component } from 'react';

import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';

import centerOhlIcon from '../../images/centerOHL24.png';


export class OHLListItem extends Component {

    state = {
        checked: true
    }

    componentDidUpdate(prevProps){
        if(prevProps.parentChecked !== this.props.parentChecked){
            this.setState({
                checked: this.props.parentChecked
            });
        }
    }

    onChange = (e, ohlName) => {
        this.setState((previousState) => ({
            checked: !previousState.checked
        }));

        this.props.onToogleOhlChecked(ohlName, e.target.checked)
    }

    render() {

        return (
            <ListItem key={this.props.name} style={{marginLeft: '25px'}}>
                <ListItemText secondary={this.props.name} />
                    {this.props.isSelectable ? <Checkbox style={{marginLeft: '10px', marginRight: '10px'}}
                        checked={this.state.checked}
                        onChange={(e) => this.onChange(e, this.props.name)}
                        color='primary'
                    /> : null}
                    <span style={{marginLeft: '10px', marginRight: '10px', cursor: 'pointer'}} >
                      {/* <img src={MoreVerticalIcon} alt='OHL options' /> */}
                      {this.state.checked ? <img src={centerOhlIcon} title='Center OHL' onClick={() => this.props.centerOHLByName(this.props.name) /*centerOHLById(this.props.ohlId)*/} alt='Center OHL' /> : <img src={centerOhlIcon} title='Center OHL'  alt='Center OHL' />}
                    </span>         
            </ListItem>
        )
    }
}


export default OHLListItem;

